import { useQuery } from 'react-apollo';
import { filterList, getId } from './helpers';
import siblingSearchQuery from './siblingSearchQuery.gql';

export const useSiblingProducts = ({ product }) => {
  //GET SEARCH TERM
  const term = getId(product)?.trim();

  //QUERY
  const result = useQuery(siblingSearchQuery, {
    variables: { term: term },
    errorPolicy: 'all',
    skip: !term
  });

  const productList = result.data?.search?.products?.result;
  if (!productList) return null;

  //THE SEARCH IS FREE TEXT, SO COUNT ONLY FAMILY-NAME MATCHES. IF NO OTHER
  //PRODUCT HAS THE SAME FAMILY-NAME IN THIS LANGUAGE, SHOW NO SIBLINGS AT ALL
  const siblings = filterList(productList, term);
  if (siblings.length > 1) return siblings;
  return null;
};
